import { render, staticRenderFns } from "./IndependentCourseThumb.vue?vue&type=template&id=98291508&scoped=true&"
import script from "./IndependentCourseThumb.vue?vue&type=script&lang=js&"
export * from "./IndependentCourseThumb.vue?vue&type=script&lang=js&"
import style0 from "./IndependentCourseThumb.vue?vue&type=style&index=0&id=98291508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98291508",
  null
  
)

export default component.exports